import { Config } from 'ha/config';
import FetchClient from 'ha/helpers/FetchClient';
import { Language } from 'ha/i18n/types';

import createTranslationService from './Translation';
import initFB from './initializers/initFB';
import initAlgolia from './initializers/initAlgolia';
import fbService from './Facebook';
import googleMapApi from './GoogleMapApi';
import createApiV2 from './apiV2';
import makeSegmentService from './segment';
import algoliaService from './algolia';
import makeStripeService from './Stripe';
import makeTwilioService from './twilio';
import makeMonetaService from './moneta';
import makeOsirisService from './osiris';
import makeHermesService from './hermes';

interface Clients {
  haApi: FetchClient;
  moneta: FetchClient;
  osiris: FetchClient;
  hermes: FetchClient;
  // tslint:disable-next-line no-any
  graphql: any;
}
interface AppServicesSetup {
  config: Config;
  clients: Clients;
  lang: Language;
}

function getAppServices({ config, clients, lang }: AppServicesSetup) {
  return {
    translation: createTranslationService(
      {
        languageDetectionURL: config.languageDetectionURL,
      },
      clients.haApi,
    ),
    graphql: clients.graphql,
    algolia: algoliaService(() =>
      initAlgolia(config.algolia.appId, config.algolia.apiKey).then(client => ({
        index: config.algolia.index,
        client,
      })),
    ),
    algoliaNext: algoliaService(() =>
      initAlgolia(config.algolia.appId, config.algolia.apiKey).then(client => ({
        index: config.algolia.indexNext,
        client,
      })),
    ),
    facebook: fbService(() => initFB(config.facebook.client_id)),
    googleMapApi: googleMapApi({ key: config.google.maps_key, language: lang }),
    apiV2: createApiV2(clients.haApi),
    hermes: makeHermesService(clients.hermes),
    moneta: makeMonetaService(clients.moneta),
    osiris: makeOsirisService(clients.osiris),
    segment: makeSegmentService(config),
    stripe: makeStripeService(config),
    twilio: makeTwilioService(),
  };
}

export type AppServices = ReturnType<typeof getAppServices>;

export default getAppServices;
